module.exports = __webpack_public_path__ + "static/media/calendar.9952f90a.png";